import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6194ab2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DeductItem" }
const _hoisted_2 = {
  key: 0,
  class: "table-col"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "table-col"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "table-col" }
const _hoisted_7 = { class: "other-btn" }
const _hoisted_8 = { class: "collapse-box" }
const _hoisted_9 = { style: {"margin":"0 20px"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  slot: "default",
  class: "el-icon-plus"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 支持 jpeg, jpg, png 格式，不超过20m ", -1))

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { createPageData, editPageData,getListData } from '@/service/main/system'
import { getPolicy } from '@/service/common/common'
import { reverseTimestamp } from '@/utils/date-format'
import { ref,reactive,onMounted} from 'vue'
import { useStore } from '@/store'
import type { ElFile, UploadFile } from 'element-plus/lib/el-upload/src/upload.type'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import { initEmptyParam } from '@/hooks/useInitParam'
import { ElMessage, ElMessageBox,ElLoading, } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickReplyManage',
  setup(__props) {

initEmptyParam()
const modalTitle = ref('新增')
const store = useStore()

// 添加控制折叠面板展开项的响应式变量
const activeCollapseItems = ref<string[]>([])
//详情 原始数据
const rawData = ref<any>({})

const formList =ref<any>([])
// 存储所有表单实例的 ref 数组
const formRefs = ref<any>([])

// 动态设置表单 ref
const setFormRef = (el:any, index:number) => {
  if (el) {
    formRefs.value[index] = el;
  }
};
// 定义校验规则
const dynamicRules = reactive({
  question: [
    { required: true, message: '问题必填', trigger: 'blur' }
  ],
  answer: [
    { required: true, message: '答案必填', trigger: 'blur' }
  ],
  name: [
    { required: true, message: '名称必填', trigger: 'blur' }
  ],
  urlList: [
    { required: true, message: '图片必传', trigger: 'blur' }
  ],
  sort: [
   { required: true, message: '请输入排序值 0-100 之间', trigger: 'blur' }
  ],
});
//类型改变事件
const handleChange = (item: any, value: any,formData:any) => {
    if(item.field == 'type'){
      defaultInfo.value.type = value
      let obj = value == '1' ? 
      {
        id: Date.now() + Math.random(), // 添加唯一标识符
        question: '',
        answer: '',
        sort:1,
        content: '',
        isDisabled:false 
      } :
      {
        id: Date.now() + Math.random(), // 添加唯一标识符
        name: '',
        sort:1,
        urlList:[],
        isDisabled:false
      }
      formList.value=[obj]
      // 将新添加的项设为展开状态
    activeCollapseItems.value = [`contents-${obj.id}`]
    }  
}
const btnDisabled=ref(false)

//基础表单提交事件
const handleConfirmClick =()=>{   
  pageModalRef.value.lfFormRef?.validate(async (isValid:any) => {
     if (isValid ){
       let formData = {...pageModalRef.value.formData}
       const pageUrl = defaultInfo.value?.templateId ? `/main/quickReply/updateCompanyTemplate` : `/main/quickReply/addCompanyTemplate`
       const put = defaultInfo.value?.templateId ? editPageData : createPageData
       const obj= defaultInfo.value?.templateId ?
            {
              serialNumber:formData.sort,
              templateTitle: formData.title,
              templateType: formData.type,
              templateId: Number(defaultInfo.value.templateId),
            }:{ 
                serialNumber:formData.sort,
                templateTitle: formData.title,
                templateType: formData.type
              }
             let res = await put(pageUrl, obj)
              if(res){
                ElMessage({ type: 'success',message: '提交成功！'})
                if(res.templateId){
                  defaultInfo.value={
                      templateId:res.templateId,
                      type: formData.type,
                      title:formData.title,
                      sort:formData.sort,
                  }
                }
                pageModalRef.value.lfFormRef.allDisabled = true
                btnDisabled.value=true
                let loadingInstance: ILoadingInstance = {} as ILoadingInstance
                if (document.querySelector('.el-table__body-wrapper')) {
                  loadingInstance = ElLoading.service({
                    target: '.el-table__body-wrapper',
                    text: '加载中....',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.8)',
                    fullscreen: false
                  })
                }
                store.dispatch('system/getPageListAction', {
                  pageName: 'quickReply',
                  queryInfo: store.state.system.queryInfo
                })
                .finally(() => {
                  if (
                    loadingInstance &&
                    typeof loadingInstance.close == 'function'
                  ) {
                    loadingInstance.close()
                  }
                })
              }else{
                ElMessage({ type: 'error',message: '操作失败！'})
              } 
     }
  })
}
//基础表单重置
const handleCancleClick =()=>{ 
  if(modalTitle.value == '新增'){
      defaultInfo.value= { type: '1'}
  }else{ 
    defaultInfo.value={
        templateId:rawData.value.templateId,
        type: rawData.value.templateType,
        title:rawData.value.templateTitle,
        sort:rawData.value.serialNumber,
    }
  }
}
const action=ref('')
const extraData=ref({})
const policyData =ref()
const filesMap = ref<Map<String, String>>(new Map)
const beforeUpload = async (file: UploadFile,item:any) => {
  policyData.value = await getPolicy()
    const key =
      policyData.value.dir +
      reverseTimestamp() +
      file.name.substring(file.name.lastIndexOf('.')) 
      extraData.value = {
        ...policyData.value,
        OSSAccessKeyId: policyData.value.accessId,
        key
      }
     action.value = policyData.value.host
     item.urlList.push(policyData.value.host + '/' + key)
     filesMap.value.set(String(file.uid), policyData.value.host + '/' + key)
}
//删除图片
const handleImgRemove = (uploadFile: any, uploadFiles: any,item: any) => {
  const list=JSON.parse(JSON.stringify(uploadFiles))
   const index = list.findIndex((file: any) => file.uid === uploadFile.uid);
   item.urlList.splice(index, 1);
}

let dialogImageUrl = ref()
const dialogVisible = ref(false)
//预览图片
const handlePreview = (file: any) => {
  dialogImageUrl.value = file.url
  dialogVisible.value = true
}

onMounted (()=>{
})
const titleList= ref([
  { title: 'xxxxxxxx1', value: '1' },
  { title: 'xxxxxxxx2', value: '2' },
  { title: 'xxxxxxxx3', value: '3' },
  { title: 'ssssssss4', value: '4' },
  { title: 'ssssss5', value: '5' },
  { title: '3333qaaa6', value: '6' },
  { title: 'aaaaaaaaa7', value: '7' },

])
//新增快捷回复项
const addItems=(items:any)=>{
  if(!items){
    items=[]
  } 
  let newItem={}
  if(pageModalRef.value.formData.type == '1'){
    newItem = {
      id: Date.now() + Math.random(), // 添加唯一标识符
      question: '',
      answer: '',
      content: '',
      sort: items.length>0 ? items[items.length-1].sort+1 :1,
      isDisabled:false
    }
  }else{
    newItem = {
      id: Date.now() + Math.random(), // 添加唯一标识符
      name: '',
      urlList:[],
      sort: items.length>0 ? items[items.length-1].sort+1 :1,
      isDisabled:false
    }
  }
  items.push(newItem)
   // 将新添加的项设为展开状态
    activeCollapseItems.value = [...activeCollapseItems.value,`contents-${newItem.id}`]
}
//删除快捷回复项
const handleItemRemove=(index:any,list:any,item:any)=>{
   if(list.length > 1){
    ElMessageBox.confirm('确定要删除吗？','注意',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=> {
      if(item.quickReplyId){
        store.dispatch('system/deletePageDataAction', {
          pageName: 'quickReply',
          id:  item.quickReplyId,
          delUrl:'/main/quickReply/deleteCompanyQuickReply'
        }).then((res)=>{
        }).catch(()=>{
            ElMessage({
            message: '删除失败',
            type: 'error'
          })
        })
      }
      list.splice(index, 1);
       // 注意：移除元素后，formRefs 数组也需要同步清理
      formRefs.value.splice(index, 1);
    }).catch(()=>{
      ElMessage({
        message: '取消删除',
        type: 'warning'
      })
    })
   }else{
    ElMessage({ type: 'warning',message: '必须保留一条或一条以上数据！'})
   }
}
// 处理快捷回复项提交
const handleSubmit = async (index:number,list:any,item:any) => {
  if(item.isDisabled) {
     item.isDisabled=false;
     return;
  }
  // 可以在这里调用 API 将数据发送到后端
  if(defaultInfo.value?.templateId){
     // 通过索引获取对应的表单实例并进行校验
     try {
        await formRefs.value[index].validate();  
        let url = item.quickReplyId ? '/main/quickReply/updateCompanyQuickReply':'/main/quickReply/addCompanyQuickReply'
        let put = item.quickReplyId ? editPageData : createPageData
        let obj = defaultInfo.value.type == '1' ? 
            { 
              answer: item.answer,
              question: item.question,
              trackingThought: item.content,
              serialNumber: item.sort,
              quickReplyId:item.quickReplyId ? Number(item.quickReplyId) : null,
              templateId:Number(defaultInfo.value.templateId),
            }:
            { 
              imageTitle: item.name,
              imageUrl:item.urlList.join(','),
              serialNumber: item.sort,
              quickReplyId:item.quickReplyId ? Number(item.quickReplyId) : null,
              templateId: Number(defaultInfo.value.templateId),
            }
          let res = await put(url,obj) 
          if(res){
              ElMessage({ type: 'success',message: '提交成功！'})
              if(res.quickReplyId){
                item.quickReplyId=res.quickReplyId
              }
               item.isDisabled=true;
            } 
        }catch(error){
          console.log('表单验证或提交失败:', error);
        } 
  }else{
    ElMessage.error(`请先提交上面的基础模板！`);
  }
};

const newCb = () => {
  modalTitle.value = '新增'
  btnDisabled.value=false
  pageModalRef.value.isBatch=true;
  defaultInfo.value= { type: '1'}
  const newItem = {
    id: Date.now() + Math.random(), // 添加唯一标识符
    question: '',
    answer: '',
    content: '',
    sort: 1,
    isDisabled:false
  }
  formList.value=[newItem] 
   
   isDisabled.value=false
   modalConfig.formItems.forEach(item => { 
      item.isDisabled=false
  })
   // 将新添加的项设为展开状态
  activeCollapseItems.value.push(`contents-${newItem.id}`)
}
const isDisabled=ref(false);
const editCb = async(item:any) => {
  modalTitle.value = '编辑'
  btnDisabled.value=false
  activeCollapseItems.value=[]
  pageModalRef.value.isBatch=true;
  pageModalRef.value.dialogVisible = false;
   let data = await getListData(`/main/quickReply/getCompanyQuickReplyDetail/${item.templateId}`,{})
    rawData.value =JSON.parse(JSON.stringify(data))
   defaultInfo.value={
        templateId:data.templateId,
        type: data.templateType,
        title:data.templateTitle,
        sort:data.serialNumber,
    }
  if(data.quickReplyList && data.quickReplyList.length>0){
    formList.value =data.templateType =='1' ? data.quickReplyList.map((val:any) => {
          return {
            question: val.question,
            answer: val.answer,
            content: val.trackingThought,
            sort: val.serialNumber,
            quickReplyId:val.quickReplyId,
            isDisabled:true
          }
        }) :data.quickReplyList.map((val:any) => {
          return {
            name: val.imageTitle,
            urlList: val.imageUrl.split(','),
            sort: val.serialNumber,
            quickReplyId:val.quickReplyId,
            isDisabled:true
          }
        })
    formList.value.forEach((element:any,index:number) => {
      if(data.templateType=='2'){
        element.urlLists = JSON.parse(JSON.stringify(element.urlList))
        element.urlLists=element.urlLists.map((item:any,idx:any) => {
            return {name:`img-${index}-${idx}`,url:item}
        })
      } 
      activeCollapseItems.value.push(`contents-${element.quickReplyId}`)
    });
  }else{
    formList.value =[]
     addItems(formList.value)
  }  
  
  pageModalRef.value.dialogVisible = true;
  isDisabled.value=true
  modalConfig.formItems.forEach(e => {
    if(e.field == 'type' || e.field == 'title' ){
      e.isDisabled = true
    } 
  })
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "quickReply",
      delUrl: "/main/quickReply/deleteCompanyTemplate",
      deleteTip: "确认删除此模版项吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      question: _withCtx((scope) => [
        (scope.row?.question )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(scope.row?.question ?? '--'), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, "--"))
      ]),
      trackingThought: _withCtx((scope) => [
        (scope.row?.trackingThought )
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(scope.row?.trackingThought ?? '--'), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, "--"))
      ]),
      numOfClicks: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_6, _toDisplayString(scope.row?.numOfClicks ?? 0), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      width: "60%",
      submitShow: false,
      pageName: "quickReply",
      validOtherInfo: () => true,
      onChange: handleChange
    }, {
      other: _withCtx(({ show }) => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: handleCancleClick,
            disabled: btnDisabled.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("重置")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: btnDisabled.value,
            onClick: handleConfirmClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_collapse, {
            modelValue: activeCollapseItems.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeCollapseItems).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_collapse_item, {
                  key: `contents-${item.id || item.quickReplyId || index}`,
                  name: `contents-${item.id || item.quickReplyId || index}`
                }, {
                  title: _withCtx(({  }) => [
                    _createElementVNode("div", _hoisted_9, " 快捷回复" + _toDisplayString(index+1), 1),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      icon: "el-icon-delete",
                      size: "mini",
                      onClick: _withModifiers(($event: any) => (handleItemRemove(index,formList.value,item)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (item.isDisabled)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-edit",
                          onClick: _withModifiers(($event: any) => (handleSubmit(index,formList.value,item)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-check",
                          onClick: _withModifiers(($event: any) => (handleSubmit(index,formList.value,item)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("提交")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      "label-width": 100,
                      model: item,
                      disabled: item.isDisabled,
                      ref_for: true,
                      ref: (el) => setFormRef(el, index),
                      rules: dynamicRules
                    }, {
                      default: _withCtx(() => [
                        (_unref(defaultInfo)?.type == '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_el_form_item, {
                                label: "问题",
                                prop: "question",
                                class: "form-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "textarea",
                                    rows: 3,
                                    autosize: { minRows: 2, maxRows: 6 },
                                    modelValue: item.question,
                                    "onUpdate:modelValue": ($event: any) => ((item.question) = $event),
                                    placeholder: "请输入问题"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_form_item, {
                                label: "答案",
                                prop: "answer",
                                class: "form-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "textarea",
                                    rows: 3,
                                    autosize: { minRows: 2, maxRows: 6 },
                                    modelValue: item.answer,
                                    "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                                    placeholder: "请输入答案"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_form_item, {
                                label: "跟踪思路",
                                class: "form-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "textarea",
                                    rows: 3,
                                    autosize: { minRows: 2, maxRows: 6 },
                                    modelValue: item.content,
                                    "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                                    placeholder: "请输入跟踪思路"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_form_item, {
                                label: "问答排序",
                                prop: "sort",
                                class: "form-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "number",
                                    style: {"width":"100px"},
                                    modelValue: item.sort,
                                    "onUpdate:modelValue": ($event: any) => ((item.sort) = $event),
                                    placeholder: "数字"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(defaultInfo)?.type == '2')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_el_form_item, {
                                label: "图片名称",
                                prop: "name",
                                class: "form-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "textarea",
                                    rows: 3,
                                    autosize: { minRows: 2, maxRows: 6 },
                                    modelValue: item.name,
                                    "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                                    placeholder: "请输入名称"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_form_item, {
                                label: "图片排序",
                                prop: "sort",
                                class: "form-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "number",
                                    style: {"width":"100px"},
                                    modelValue: item.sort,
                                    "onUpdate:modelValue": ($event: any) => ((item.sort) = $event),
                                    placeholder: "数字"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_form_item, {
                                label: "图片",
                                prop: "urlList",
                                class: "form-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_upload, {
                                    "auto-upload": true,
                                    action: action.value,
                                    data: extraData.value,
                                    "file-list": item.urlLists,
                                    "before-upload": (file) => beforeUpload(file,item) ,
                                    accept: ".jpeg,.jpg,.png",
                                    "before-remove": (uploadFile, uploadFiles) => handleImgRemove(uploadFile, uploadFiles, item),
                                    multiple: "",
                                    "list-type": "picture-card",
                                    "on-preview": handlePreview
                                  }, {
                                    tip: _withCtx(() => [
                                      _hoisted_13
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_12
                                    ]),
                                    _: 2
                                  }, 1032, ["action", "data", "file-list", "before-upload", "before-remove"])
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["model", "disabled", "rules"])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin":"10px 0 10px 100px"},
            icon: "el-icon-plus",
            size: "mini",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addItems(formList.value)))
          })
        ])
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title"]),
    _createVNode(_component_el_dialog, {
      title: "图片预览",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      width: "50%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_image, {
          src: _unref(dialogImageUrl),
          fit: "fit",
          lazy: ""
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})